'use client'

import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import { cva, VariantProps } from 'class-variance-authority'

import { cn } from '../../lib/utils'

const switchVariants = cva(
  'disabled:opacity-50 bg-teal-600 hover:bg-teal-500 relative peer inline-block border-2 border-solid border-transparent cursor-pointer rounded-full transition-colors data-[state=unchecked]:bg-input',
  {
    variants: {
      size: {
        sm: 'h-4 w-8 [&>span]:h-3 [&>span]:w-3',
        md: 'h-6 w-11 [&>span]:h-5 [&>span]:w-5',
        lg: 'h-8 w-16 [&>span]:h-7 [&>span]:w-7',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
)

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>,
    VariantProps<typeof switchVariants> {}

function Switch({ className, size = 'md', ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(switchVariants({ size: size }), className)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'inline-block absolute top-1/2 bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none rounded-full ring-0 transition-all -translate-y-1/2 data-[state=checked]:-translate-x-full data-[state=unchecked]:translate-x-0 data-[state=checked]:left-full data-[state=unchecked]:left-0'
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
